import { defaultTheme } from 'react-admin';
import merge from 'lodash/merge';
import { lighten, darken } from './utils/colorutils';

const primary = '#534cda';
const secondary = '#373737';

const theme = merge({}, defaultTheme, {
    palette: {
        primary: {
            main: primary,
            light: lighten(primary, 10),
            dark: darken(primary, 10),
        },
        secondary: {
            main: secondary,
            light: lighten(secondary, 10),
            dark: darken(secondary, 10),
        },
    },

    overrides: {
        RaLayout: {
            root: {
                minWidth: 0,
                width: '100%',
                overflowX: 'hidden',
            },
            contentWithSidebar: {
                minWidth: 0,
                width: '100%',
                overflowX: 'hidden',
            },
            content: {
                minWidth: 0,
                overflowX: 'hidden',
            },
        },

        RaSidebar: {
            root: {
                width: 240,
                minWidth: 240,
                flexShrink: 0,
            },
            drawerPaper: {
                position: 'fixed',
                left: 0,
                top: '3em',
                width: 240,
                height: 'calc(100vh - 3em)',
                zIndex: 3,
                '@media (max-width:600px)': {
                    top: 0,
                    height: '100vh',
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                },
            },
        },

        RaList: {
            root: {
                height: 'calc(100vh - 48px)',
                minHeight: 0,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
            },
            main: {
                minHeight: 0,
                flex: '1 1 auto',
                overflow: 'hidden',
            },
            content: {
                minHeight: 0,
                height: '100%',
                overflowX: 'auto',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',

                '& .MuiTablePagination-root': {
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 4,
                    backgroundColor: '#ffffff',
                    flexShrink: 0,
                },
            },
            bulkActionsDisplayed: {
                marginTop: 0,
                transition: 'none',
            },

        },

        RaDatagrid: {
            headerCell: {
                top: 0,
                zIndex: 3,
            },
        },

    },
});

export default theme;
